import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { SeoListFragmentFragmentDoc } from '@packages/gql/generated/shopping/SeoListFragmentFragmentDoc';
import { SeoElement } from '../SeoElement';
import { SeoImageLink } from '../SeoImageLink';

/* GraphQL */ `
  fragment SeoListFragment on Product {
    name
    slug
    media {
      url
    }
    seoLinks: seo(locale: $locale) {
      ...SeoElementFragment
    }
  }
`;

export type SeoListProps = {
  productData: FragmentType<typeof SeoListFragmentFragmentDoc>;
};

export const SeoList = ({ productData }: SeoListProps) => {
  const { media, name, slug, seoLinks } = getFragmentData(SeoListFragmentFragmentDoc, productData);

  return (
    <>
      {media.length > 0 && media[0].url && (
        <SeoImageLink productName={name!} slug={slug!} imgSrc={media[0].url} />
      )}
      {seoLinks && <SeoElement data={seoLinks} />}
    </>
  );
};
